import { c as _c } from "react/compiler-runtime";
import { cs2_metablob_v1 } from '../../../convex/metablobs/cs2/v1';
export const CS2ActivityFace = t0 => {
  const $ = _c(23);
  const {
    metablob: cs2v1,
    size: t1,
    variant: t2
  } = t0;
  t1 === undefined ? 96 : t1;
  const variant = t2 === undefined ? "normal" : t2;
  if (!cs2v1) {
    return null;
  }
  const didWin = cs2v1.playerTeam !== "" && cs2v1.winTeam !== "" ? cs2v1.playerTeam === cs2v1.winTeam : null;
  const borderClass = didWin === null ? "border-l-border" : didWin ? "border-l-green-400" : "border-l-red-400";
  const scoreLine = cs2v1.playerTeam == "T" ? `${cs2v1.tScore}-${cs2v1.ctScore}` : `${cs2v1.ctScore}-${cs2v1.tScore}`;
  if (variant === "slim") {
    const t3 = `border-l-2 pl-2 ${borderClass}`;
    const t4 = cs2v1.mapName || "CS2";
    let t5;
    if ($[0] !== cs2v1.mode || $[1] !== t4) {
      t5 = <div className="font-semibold leading-none">{cs2v1.mode} on {t4}</div>;
      $[0] = cs2v1.mode;
      $[1] = t4;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    let t6;
    if ($[3] !== scoreLine) {
      t6 = <div className="text-muted-foreground leading-none">{scoreLine}</div>;
      $[3] = scoreLine;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] !== t3 || $[6] !== t5 || $[7] !== t6) {
      t7 = <div className="flex flex-row items-center"><div className={t3}>{t5}{t6}</div></div>;
      $[5] = t3;
      $[6] = t5;
      $[7] = t6;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    return t7;
  }
  const t3 = `border-l-4 pl-3 ${borderClass}`;
  const t4 = cs2v1.mapName || "CS2";
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="font-semibold leading-none">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== scoreLine) {
    t6 = <div className="text-muted-foreground leading-none">{scoreLine}</div>;
    $[11] = scoreLine;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="flex flex-row items-center gap-2">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = cs2v1.mode || "match";
  const t9 = cs2v1.playerName ? `• ${cs2v1.playerName}` : "";
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="text-muted-foreground leading-none">{t8} {t9}</div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t7) {
    t11 = <div className="flex flex-row items-center"><div className={t3}>{t7}{t10}</div></div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};